import http, { url } from '../../http'

const API_URL = "ocupational_medical"

class OcupationalMedicineAPI {

  async save(ocupationalMedicine) {
    const response = await http(`${API_URL}/save`, 'POST', ocupationalMedicine)
    return response
  }

  async getEmail(ocupationalMedicine) {
    const response = await http(`ocupational_medical_danger/formatEmail`, 'POST', ocupationalMedicine)
    return response
  }

  async getAllMedicine() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getAllMedicineCompany(id, page, search) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}&search=${search}` , 'POST')
    return response
  } 
  async getAllMedicinePage(companiesID, page, search) {
    const response = await http(`${API_URL}/companies/${companiesID}?page=${page}&search=${search}` , 'POST')
    return response || null
  }
 

  async getMedicine(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateMedicine(id, medicina) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', medicina)
    return response
  }
 
  async deleteMedicine(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }



  async getEmployeeMedicine(id) {
    const response = await http(`${API_URL}/employee/${id}`)
    return response
  }

  async standardMedicine(companiesID) {
    const response = await http(`${API_URL}/standard-check/${companiesID}`, 'POST', companiesID)
    return response || null
  }
  
}

export default new OcupationalMedicineAPI()